export const SupportedLanguages = [
    {locale: 'nl', label: '🇳🇱 NL'},
    {locale: 'en', label: '🇬🇧 EN'},
];

export const SupportedLocales = SupportedLanguages.map(language => language.locale);

export default SupportedLanguages;

